import React, { useContext, useEffect, useState } from "react";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import service from "../../../../api/services";
import organisms from "../../../../components/organisms";
import { Default_Page_Limit, Default_Page_Number } from "../../../../constants/defaultValues";
import { HeaderHeading } from "../../../../Context";
import { TParams, TProcessListing } from "./interface";

const { OrgMovementInProcess } = organisms;

const Index = () => {
    const { setHeader }: any = useContext(HeaderHeading);
    const [processListing, setProcessListing] = useState<TProcessListing>();
    const [params, setParams] = useState<TParams>({
        page: Default_Page_Number,
        limit: Default_Page_Limit,
        search: "",
    });

    const getInProcessListing = async () => {
        try {
            const response: any = await service.movementService.processProcurement(params);
            setProcessListing(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const updateParams = (name: string, value: number | string) => {
        if (name === "search") {
            setParams((prevState) => ({
                ...prevState,
                [name]: value as string,
                page: Default_Page_Number,
            }));
        } else {
            setParams((prevState) => ({ ...prevState, [name]: value }));
        }
    };


    useEffect(() => {
        setHeader("Movement - In Process");
    }, []);

    useEffect(() => {
        getInProcessListing();
    }, [params]);

    return (
        <Wrapper>
            <OrgMovementInProcess
                limit={params?.limit}
                currentPage={params?.page}
                processListing={processListing}
                setSearch={(value: string) => updateParams("search", value)}
                setLimitPerPage={(value: number) => updateParams("limit", value)}
                setCurrentPage={(value: number) => updateParams("page", value)}
            />
        </Wrapper>
    );
};

export default Index;
